import { Box } from "@mui/material";
import { HourglassEmptyRounded } from "@mui/icons-material";
import { COLOR_LESS_BLACK } from "../../data/colors/Colors";
import { CustomTextView } from "./CustomTextView";

interface p {
  minHeight?: string | number;
  color?: string;
}
export function EmptyView(p: p) {
  return (
    <Box
      sx={{
        minHeight: p.minHeight ?? "70vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <HourglassEmptyRounded
        fontSize="large"
        sx={{ color: p.color ?? COLOR_LESS_BLACK }}
      />
      <CustomTextView
        text="Nothing to Show"
        variant="h5"
        fontWeight="bold"
        textColor={p.color ?? COLOR_LESS_BLACK}
      />
    </Box>
  );
}
